<template>
  <div class="container-packages pb-10">
    <div class="row row-title">
      <div class="col color-white text-center">
        <h1>¡Dilo con Nieve de Olla!</h1>
      </div>
    </div>
    <div class="row row-info">
      <div class="col color-white text-center">
        <h2>1. PERSONALIZA TU PAQUETE</h2>
        <h5>
          Elije el tamaño (1/2 litro ó 1/4 litro) y la cantidad <br>
          de helados, barritas o conos que quieras mandar.
        </h5>
      </div>
    </div>
    <div class="row align-items-end">
      <div
        v-for="(item, index) of packages"
        :key="index"
        class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-4 text-center color-white font-general-r cursor-pointer"
      >
        <div class="row align-items-start">
          <div class="col">
            <h2 v-html="item.name"></h2>
          </div>
        </div>

        <div class="row align-items-center">
          <div class="col">
            <img
              :class="`${index == 0 || index == 3 ? 'package-img-potes' : 'package-img'}`"
              loading="lazy"
              :src="item.url_image"
              :alt="item.name"
            >
          </div>
        </div>

        <div class="row align-items-end">
          <div class="col">
            <h5 class="mt-5" v-html="item.description"></h5>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['packages'],
  methods: {
    selectPackage(data) {
      this.$emit('selectPackage', data)
    }
  }
}
</script>

<style scoped>
.container-packages {
  background-color: var(--color-tertiary);
  width: 100%;
  font-family: var(--font-baloo-regular);
  padding: 15px;
}
.container-packages .row-title {
  margin-bottom: 2%;
  margin-top: 2%;
}
.container-packages .row-info {
  margin-bottom: 2%;
}
.package-img {
  width: 35%;
  margin-top: 15%;
}
.package-img-potes {
  width: 25%;
}
.container-packages {
  margin-bottom: 5%;
}
@media only screen and (min-width: 960px) and (max-width: 1264px) {
  .container-packages h1 {
    font-size: 30px !important;
  }
  .container-packages h2 {
    font-size: 25px !important;
  }
  .container-packages {
    margin-bottom: 5%;
  }
}
@media (max-width: 768px) {
  .package-img {
    width: 60%;
    margin-top: 40%;
  }
  .package-img-potes {
    width: 50%;
  }
  .container-packages h1 {
    font-size: 30px !important;
  }
  .container-packages h2 {
    font-size: 25px !important;
  }
  .container-packages {
    margin-bottom: 5%;
  }
}
@media only screen and (min-width: 360px) and (max-width: 490px) {
  .container-packages h1 {
    font-size: 22px !important;
  }
  .container-packages h2 {
    font-size: 16px !important;
  }
  .container-packages h5 {
    font-size: 14px !important;
  }
  .package-img {
    width: 80%;
    margin-top: 40%;
  }
  .package-img-potes {
    width: 60%;
  }
  .container-packages {
    margin-bottom: 10%;
  }
}
</style>
